const domain = "https://boostcareer.click";
// const domain = "http://localhost:4000";

export default domain;
